/*!
 * PhotoSwipe Lightbox 5.3.2 - https://photoswipe.com
 * (c) 2022 Dmytro Semenov
 */ !(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : ((t =
        "undefined" != typeof globalThis
          ? globalThis
          : t || self).PhotoSwipeLightbox = e());
})(this, function () {
  "use strict";
  function t(t, e, i) {
    let s = document.createElement(e || "div");
    return t && (s.className = t), i && i.appendChild(s), s;
  }
  function e(t, e, i) {
    (t.style.width = "number" == typeof e ? e + "px" : e),
      (t.style.height = "number" == typeof i ? i + "px" : i);
  }
  let i = "loading",
    s = "loaded",
    n = "error";
  function h(t, e, i = document) {
    let s = [];
    if (t instanceof Element) s = [t];
    else if (t instanceof NodeList || Array.isArray(t)) s = Array.from(t);
    else {
      let n = "string" == typeof t ? t : e;
      n && (s = Array.from(i.querySelectorAll(n)));
    }
    return s;
  }
  function a() {
    return !(!navigator.vendor || !navigator.vendor.match(/apple/i));
  }
  class l {
    constructor(t, e) {
      (this.type = t), e && Object.assign(this, e);
    }
    preventDefault() {
      this.defaultPrevented = !0;
    }
  }
  class o {
    constructor(e, i) {
      (this.element = t("pswp__img pswp__img--placeholder", e ? "img" : "", i)),
        e &&
          ((this.element.decoding = "async"),
          (this.element.alt = ""),
          (this.element.src = e),
          this.element.setAttribute("role", "presentation")),
        this.element.setAttribute("aria-hiden", "true");
    }
    setDisplayedSize(t, i) {
      var s;
      let n;
      this.element &&
        ("IMG" === this.element.tagName
          ? (e(this.element, 250, "auto"),
            (this.element.style.transformOrigin = "0 0"),
            (this.element.style.transform =
              ((n = "translate3d(0px,0px,0)"),
              (s = t / 250),
              (n += " scale3d(" + s + "," + s + ",1)"),
              n)))
          : e(this.element, t, i));
    }
    destroy() {
      this.element.parentNode && this.element.remove(), (this.element = null);
    }
  }
  class r {
    constructor(t, e, i) {
      (this.instance = e),
        (this.data = t),
        (this.index = i),
        (this.element = void 0),
        (this.displayedImageWidth = 0),
        (this.displayedImageHeight = 0),
        (this.width = Number(this.data.w) || Number(this.data.width) || 0),
        (this.height = Number(this.data.h) || Number(this.data.height) || 0),
        (this.isAttached = !1),
        (this.hasSlide = !1),
        (this.state = "idle"),
        this.data.type
          ? (this.type = this.data.type)
          : this.data.src
          ? (this.type = "image")
          : (this.type = "html"),
        this.instance.dispatch("contentInit", { content: this });
    }
    removePlaceholder() {
      this.placeholder &&
        !this.keepPlaceholder() &&
        setTimeout(() => {
          this.placeholder &&
            (this.placeholder.destroy(), (this.placeholder = null));
        }, 1e3);
    }
    load(e, i) {
      if (this.slide && this.usePlaceholder()) {
        if (this.placeholder) {
          let s = this.placeholder.element;
          s && !s.parentElement && this.slide.container.prepend(s);
        } else {
          let n = this.instance.applyFilters(
            "placeholderSrc",
            !(!this.data.msrc || !this.slide.isFirstSlide) && this.data.msrc,
            this
          );
          this.placeholder = new o(n, this.slide.container);
        }
      }
      (this.element && !i) ||
        this.instance.dispatch("contentLoad", { content: this, isLazy: e })
          .defaultPrevented ||
        (this.isImageContent()
          ? ((this.element = t("pswp__img", "img")),
            this.displayedImageWidth && this.loadImage(e))
          : ((this.element = t("pswp__content")),
            (this.element.innerHTML = this.data.html || "")),
        i && this.slide && this.slide.updateContentSize(!0));
    }
    loadImage(t) {
      let e = this.element;
      this.instance.dispatch("contentLoadImage", { content: this, isLazy: t })
        .defaultPrevented ||
        (this.updateSrcsetSizes(),
        this.data.srcset && (e.srcset = this.data.srcset),
        (e.src = this.data.src),
        (e.alt = this.data.alt || ""),
        (this.state = i),
        e.complete
          ? this.onLoaded()
          : ((e.onload = () => {
              this.onLoaded();
            }),
            (e.onerror = () => {
              this.onError();
            })));
    }
    setSlide(t) {
      (this.slide = t), (this.hasSlide = !0), (this.instance = t.pswp);
    }
    onLoaded() {
      (this.state = s),
        this.slide &&
          (this.instance.dispatch("loadComplete", {
            slide: this.slide,
            content: this,
          }),
          this.slide.isActive &&
            this.slide.heavyAppended &&
            !this.element.parentNode &&
            (this.append(), this.slide.updateContentSize(!0)),
          (this.state !== s && this.state !== n) || this.removePlaceholder());
    }
    onError() {
      (this.state = n),
        this.slide &&
          (this.displayError(),
          this.instance.dispatch("loadComplete", {
            slide: this.slide,
            isError: !0,
            content: this,
          }),
          this.instance.dispatch("loadError", {
            slide: this.slide,
            content: this,
          }));
    }
    isLoading() {
      return this.instance.applyFilters(
        "isContentLoading",
        this.state === i,
        this
      );
    }
    isError() {
      return this.state === n;
    }
    isImageContent() {
      return "image" === this.type;
    }
    setDisplayedSize(t, i) {
      if (
        this.element &&
        (this.placeholder && this.placeholder.setDisplayedSize(t, i),
        !this.instance.dispatch("contentResize", {
          content: this,
          width: t,
          height: i,
        }).defaultPrevented &&
          (e(this.element, t, i), this.isImageContent() && !this.isError()))
      ) {
        let s = !this.displayedImageWidth && t;
        (this.displayedImageWidth = t),
          (this.displayedImageHeight = i),
          s ? this.loadImage(!1) : this.updateSrcsetSizes(),
          this.slide &&
            this.instance.dispatch("imageSizeChange", {
              slide: this.slide,
              width: t,
              height: i,
              content: this,
            });
      }
    }
    isZoomable() {
      return this.instance.applyFilters(
        "isContentZoomable",
        this.isImageContent() && this.state !== n,
        this
      );
    }
    updateSrcsetSizes() {
      if (this.data.srcset) {
        let t = this.element,
          e = this.instance.applyFilters(
            "srcsetSizesWidth",
            this.displayedImageWidth,
            this
          );
        (!t.dataset.largestUsedSize ||
          e > parseInt(t.dataset.largestUsedSize, 10)) &&
          ((t.sizes = e + "px"), (t.dataset.largestUsedSize = String(e)));
      }
    }
    usePlaceholder() {
      return this.instance.applyFilters(
        "useContentPlaceholder",
        this.isImageContent(),
        this
      );
    }
    lazyLoad() {
      this.instance.dispatch("contentLazyLoad", { content: this })
        .defaultPrevented || this.load(!0);
    }
    keepPlaceholder() {
      return this.instance.applyFilters(
        "isKeepingPlaceholder",
        this.isLoading(),
        this
      );
    }
    destroy() {
      (this.hasSlide = !1),
        (this.slide = null),
        this.instance.dispatch("contentDestroy", { content: this })
          .defaultPrevented ||
          (this.remove(),
          this.placeholder &&
            (this.placeholder.destroy(), (this.placeholder = null)),
          this.isImageContent() &&
            this.element &&
            ((this.element.onload = null),
            (this.element.onerror = null),
            (this.element = null)));
    }
    displayError() {
      if (this.slide) {
        let e = t("pswp__error-msg");
        (e.innerText = this.instance.options.errorMsg),
          (e = this.instance.applyFilters("contentErrorElement", e, this)),
          (this.element = t("pswp__content pswp__error-msg-container")),
          this.element.appendChild(e),
          (this.slide.container.innerText = ""),
          this.slide.container.appendChild(this.element),
          this.slide.updateContentSize(!0),
          this.removePlaceholder();
      }
    }
    append() {
      if (this.isAttached) return;
      if (((this.isAttached = !0), this.state === n))
        return void this.displayError();
      if (
        this.instance.dispatch("contentAppend", { content: this })
          .defaultPrevented
      )
        return;
      let t = "decode" in this.element;
      this.isImageContent()
        ? t && this.slide && (!this.slide.isActive || a())
          ? ((this.isDecoding = !0),
            this.element.decode().finally(() => {
              (this.isDecoding = !1), this.appendImage();
            }))
          : this.appendImage()
        : this.element &&
          !this.element.parentNode &&
          this.slide.container.appendChild(this.element);
    }
    activate() {
      this.instance.dispatch("contentActivate", { content: this })
        .defaultPrevented ||
        (this.slide &&
          (this.isImageContent() && this.isDecoding && !a()
            ? this.appendImage()
            : this.isError() && this.load(!1, !0)));
    }
    deactivate() {
      this.instance.dispatch("contentDeactivate", { content: this });
    }
    remove() {
      (this.isAttached = !1),
        this.instance.dispatch("contentRemove", { content: this })
          .defaultPrevented ||
          (this.element && this.element.parentNode && this.element.remove(),
          this.placeholder &&
            this.placeholder.element &&
            this.placeholder.element.remove());
    }
    appendImage() {
      this.isAttached &&
        (this.instance.dispatch("contentAppendImage", { content: this })
          .defaultPrevented ||
          (this.slide &&
            this.element &&
            !this.element.parentNode &&
            this.slide.container.appendChild(this.element),
          (this.state !== s && this.state !== n) || this.removePlaceholder()));
    }
  }
  function d(t, e, i, s, n) {
    let h;
    if (e.paddingFn) h = e.paddingFn(i, s, n)[t];
    else if (e.padding) h = e.padding[t];
    else {
      let a = "padding" + t[0].toUpperCase() + t.slice(1);
      e[a] && (h = e[a]);
    }
    return h || 0;
  }
  class p {
    constructor(t, e, i, s) {
      (this.pswp = s),
        (this.options = t),
        (this.itemData = e),
        (this.index = i);
    }
    update(t, e, i) {
      (this.elementSize = { x: t, y: e }), (this.panAreaSize = i);
      let s = this.panAreaSize.x / this.elementSize.x,
        n = this.panAreaSize.y / this.elementSize.y;
      (this.fit = Math.min(1, s < n ? s : n)),
        (this.fill = Math.min(1, s > n ? s : n)),
        (this.vFill = Math.min(1, n)),
        (this.initial = this.t()),
        (this.secondary = this.i()),
        (this.max = Math.max(this.initial, this.secondary, this.o())),
        (this.min = Math.min(this.fit, this.initial, this.secondary)),
        this.pswp &&
          this.pswp.dispatch("zoomLevelsUpdate", {
            zoomLevels: this,
            slideData: this.itemData,
          });
    }
    l(t) {
      let e = this.options[t + "ZoomLevel"];
      if (e)
        return "function" == typeof e
          ? e(this)
          : "fill" === e
          ? this.fill
          : "fit" === e
          ? this.fit
          : Number(e);
    }
    i() {
      let t = this.l("secondary");
      return (
        t ||
        ((t = Math.min(1, 3 * this.fit)) * this.elementSize.x > 4e3 &&
          (t = 4e3 / this.elementSize.x),
        t)
      );
    }
    t() {
      return this.l("initial") || this.fit;
    }
    o() {
      let t = this.l("max");
      return t || Math.max(1, 4 * this.fit);
    }
  }
  function c(t, e, i) {
    var s, n, h, a;
    let l = e.createContentFromData(t, i);
    if (!l || !l.lazyLoad) return;
    let { options: o } = e,
      r =
        e.viewportSize ||
        (function (t, e) {
          if (t.getViewportSizeFn) {
            let i = t.getViewportSizeFn(t, e);
            if (i) return i;
          }
          return {
            x: document.documentElement.clientWidth,
            y: window.innerHeight,
          };
        })(o, e),
      c =
        ((s = o),
        (n = r),
        (h = t),
        (a = i),
        {
          x: n.x - d("left", s, n, h, a) - d("right", s, n, h, a),
          y: n.y - d("top", s, n, h, a) - d("bottom", s, n, h, a),
        }),
      m = new p(o, t, -1);
    return (
      m.update(l.width, l.height, c),
      l.lazyLoad(),
      l.setDisplayedSize(
        Math.ceil(l.width * m.initial),
        Math.ceil(l.height * m.initial)
      ),
      l
    );
  }
  return class extends class extends class {
    constructor() {
      (this.u = {}),
        (this.p = {}),
        (this.pswp = void 0),
        (this.options = void 0);
    }
    addFilter(t, e, i = 100) {
      this.p[t] || (this.p[t] = []),
        this.p[t].push({ fn: e, priority: i }),
        this.p[t].sort((t, e) => t.priority - e.priority),
        this.pswp && this.pswp.addFilter(t, e, i);
    }
    removeFilter(t, e) {
      this.p[t] && (this.p[t] = this.p[t].filter((t) => t.fn !== e)),
        this.pswp && this.pswp.removeFilter(t, e);
    }
    applyFilters(t, ...e) {
      return (
        this.p[t] &&
          this.p[t].forEach((t) => {
            e[0] = t.fn.apply(this, e);
          }),
        e[0]
      );
    }
    on(t, e) {
      this.u[t] || (this.u[t] = []),
        this.u[t].push(e),
        this.pswp && this.pswp.on(t, e);
    }
    off(t, e) {
      this.u[t] && (this.u[t] = this.u[t].filter((t) => e !== t)),
        this.pswp && this.pswp.off(t, e);
    }
    dispatch(t, e) {
      if (this.pswp) return this.pswp.dispatch(t, e);
      let i = new l(t, e);
      return (
        this.u &&
          this.u[t] &&
          this.u[t].forEach((t) => {
            t.call(this, i);
          }),
        i
      );
    }
  } {
    getNumItems() {
      let t,
        { dataSource: e } = this.options;
      e
        ? "length" in e
          ? (t = e.length)
          : "gallery" in e &&
            (e.items || (e.items = this.m(e.gallery)),
            e.items && (t = e.items.length))
        : (t = 0);
      let i = this.dispatch("numItems", { dataSource: e, numItems: t });
      return this.applyFilters("numItems", i.numItems, e);
    }
    createContentFromData(t, e) {
      return new r(t, this, e);
    }
    getItemData(t) {
      let { dataSource: e } = this.options,
        i;
      Array.isArray(e)
        ? (i = e[t])
        : e &&
          e.gallery &&
          (e.items || (e.items = this.m(e.gallery)), (i = e.items[t]));
      let s = i;
      s instanceof Element && (s = this.g(s));
      let n = this.dispatch("itemData", { itemData: s || {}, index: t });
      return this.applyFilters("itemData", n.itemData, t);
    }
    m(t) {
      return this.options.children || this.options.childSelector
        ? h(this.options.children, this.options.childSelector, t) || []
        : [t];
    }
    g(t) {
      let e = { element: t },
        i = "A" === t.tagName ? t : t.querySelector("a");
      if (i) {
        (e.src = i.dataset.pswpSrc || i.href),
          i.dataset.pswpSrcset && (e.srcset = i.dataset.pswpSrcset),
          (e.width = parseInt(i.dataset.pswpWidth, 10)),
          (e.height = parseInt(i.dataset.pswpHeight, 10)),
          (e.w = e.width),
          (e.h = e.height),
          i.dataset.pswpType && (e.type = i.dataset.pswpType);
        let s = t.querySelector("img");
        s &&
          ((e.msrc = s.currentSrc || s.src), (e.alt = s.getAttribute("alt"))),
          (i.dataset.pswpCropped || i.dataset.cropped) && (e.thumbCropped = !0);
      }
      return this.applyFilters("domItemData", e, t, i);
    }
    lazyLoadData(t, e) {
      return c(t, this, e);
    }
  } {
    constructor(t) {
      super(), (this.options = t || {}), (this.v = 0);
    }
    init() {
      (this.onThumbnailsClick = this.onThumbnailsClick.bind(this)),
        h(this.options.gallery, this.options.gallerySelector).forEach((t) => {
          t.addEventListener("click", this.onThumbnailsClick, !1);
        });
    }
    onThumbnailsClick(t) {
      if (
        (function (t) {
          if (2 === t.which || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey)
            return !0;
        })(t) ||
        window.pswp ||
        !1 === window.navigator.onLine
      )
        return;
      let e = { x: t.clientX, y: t.clientY };
      e.x || e.y || (e = null);
      let i = this.getClickedIndex(t);
      i = this.applyFilters("clickedIndex", i, t, this);
      let s = { gallery: t.currentTarget };
      i >= 0 && (t.preventDefault(), this.loadAndOpen(i, s, e));
    }
    getClickedIndex(t) {
      if (this.options.getClickedIndexFn)
        return this.options.getClickedIndexFn.call(this, t);
      let e = t.target,
        i = h(
          this.options.children,
          this.options.childSelector,
          t.currentTarget
        ).findIndex((t) => t === e || t.contains(e));
      return -1 !== i
        ? i
        : this.options.children || this.options.childSelector
        ? -1
        : 0;
    }
    loadAndOpen(t, e, i) {
      return (
        !window.pswp &&
        ((this.options.index = t),
        (this.options.initialPointerPos = i),
        (this.shouldOpen = !0),
        this.preload(t, e),
        !0)
      );
    }
    preload(t, e) {
      var i;
      let { options: s } = this;
      e && (s.dataSource = e);
      let n = [],
        h = typeof s.pswpModule;
      if (
        "function" == typeof (i = s.pswpModule) &&
        i.prototype &&
        i.prototype.goTo
      )
        n.push(Promise.resolve(s.pswpModule));
      else {
        if ("string" === h)
          throw Error("pswpModule as string is no longer supported");
        if ("function" !== h) throw Error("pswpModule is not valid");
        n.push(s.pswpModule());
      }
      "function" == typeof s.openPromise && n.push(s.openPromise()),
        !1 !== s.preloadFirstSlide &&
          t >= 0 &&
          (this._ = (function (t, e) {
            let i = e.getItemData(t);
            if (
              !e.dispatch("lazyLoadSlide", { index: t, itemData: i })
                .defaultPrevented
            )
              return c(i, e, t);
          })(t, this));
      let a = ++this.v;
      Promise.all(n).then((t) => {
        if (this.shouldOpen) {
          let e = t[0];
          this.I(e, a);
        }
      });
    }
    I(t, e) {
      if (
        (e !== this.v && this.shouldOpen) ||
        ((this.shouldOpen = !1), window.pswp)
      )
        return;
      let i =
        "object" == typeof t
          ? new t.default(this.options)
          : new t(this.options);
      (this.pswp = i),
        (window.pswp = i),
        Object.keys(this.u).forEach((t) => {
          this.u[t].forEach((e) => {
            i.on(t, e);
          });
        }),
        Object.keys(this.p).forEach((t) => {
          this.p[t].forEach((e) => {
            i.addFilter(t, e.fn, e.priority);
          });
        }),
        this._ && (i.contentLoader.addToCache(this._), (this._ = null)),
        i.on("destroy", () => {
          (this.pswp = null), (window.pswp = null);
        }),
        i.init();
    }
    destroy() {
      this.pswp && this.pswp.destroy(),
        (this.shouldOpen = !1),
        (this.u = null),
        h(this.options.gallery, this.options.gallerySelector).forEach((t) => {
          t.removeEventListener("click", this.onThumbnailsClick, !1);
        });
    }
  };
});
